import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_CLIENTS } from '../actions';

const loadClientsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_CLIENTS).mergeMap(action =>
        Observable.from(api.fetchClients(action.payload))
            .map(response => actions.loadClientsSuccess(response.data))
            .catch(() =>
                Observable.of(
                    actions.loadClientsFailure('Problem loading freelancers'),
                ),
            ),
    );

export default loadClientsEpic;
